import $ from 'jquery'
import { debounce } from './utilities'

function Header() {
	var $header   		= $('.c-header_container'),
			logo      		= document.querySelector( '.c-header_logo' ),
			lastSCrollTop = 0;

	$(window).scroll(function() {
		var thisScrollTop = $(this).scrollTop();

		thisScrollTop > lastSCrollTop
			? $header.addClass('is-scroll-down').removeClass('is-scroll-up')
				: $header.addClass('is-scroll-up').removeClass('is-scroll-down');

		if( thisScrollTop == 0 ) {
			$header.removeClass('is-scroll-up is-scroll-down');
		}

		lastSCrollTop = thisScrollTop;
	});

	logo.classList.add( 'initialized' );

	// Set header height as CSS variable

	let header = document.querySelector('.c-header_container');

	setHeaderHeightVar()	
	window.addEventListener('resize', debounce(setHeaderHeightVar))

	function setHeaderHeightVar() {
		const height     = document.documentElement.style.getPropertyValue('--header-height'),
					calcHeight = `${header.offsetHeight}px`;
		
		if( height !== calcHeight ) {		
			document.documentElement.style.setProperty('--header-height', calcHeight)
		}
	}
}

export { Header }